import api  from 'api'

export const pathRoutes: Map<string, IRoute> = new Map()

export async function install(routes: IRoute[]) {
	for (let route of routes) {
		pathRoutes.set(route.path, route)
	}
}

export function getRouteByPath(path: string): IRoute {
	return pathRoutes.get(path)!
}


let systemList:SystemVo[] = [];
let currentSystem:SystemVo = null;
let currentModelingSystem:SystemVo = null;
let activeModule:ModuleVo = null;

export const appModule = {
	set:(sysList:SystemVo[]) =>{
		systemList = sysList
		currentSystem = systemList.find(s => s.current) || {code: '00',current: true,enabled: 1,name: '系统管理'}
		currentModelingSystem = currentModelingSystem || currentSystem
	},
	getSystemList :() =>{
		return systemList;
	},
	getCurrSystem :() =>{
		return currentSystem;
	},
	getModule : () =>{
		return currentSystem.moduleGroupList || [] as ModuleGroupVo[]
	},
	getCurrGroupCodeByPath: () => {
		let pathnames = window.location.pathname.split('/')
		if (pathnames.length > 1) {
			return pathnames[1].substring(0, 4)
		}
		return '0000'
	},
	getCurrPathModule: () => {
		let currModule = {name:'',url:''};
		appModule.getModule().map((group:ModuleGroupVo)=>{
			group.moduleList && group.moduleList.map((m:ModuleVo)=>{
				if(m.url === window.location.pathname){
					currModule.name = m.name;
					currModule.url = m.url;
				}
			})
		})
		return currModule;
	},
	getSysCodeByPath: (pathname: string) => {
		let pathnames = pathname.split('/')
		if (pathnames.length > 1) {
			return pathnames[1].substring(0, 2)
		}
		return '00'
	},
	setCurrentModelingSystem:(systemCode: string) =>{
		currentModelingSystem = systemList.find(s => s.code===systemCode) || {code: '00',current: true,enabled: 1,name: '系统管理'}
	},
	getCurrentModelingSystem :() =>{
		return currentModelingSystem;
	},
	setCurrModule: async (modulevo: ModuleVo) =>{
		activeModule = modulevo;
		let actionCode = modulevo.fullCode + '00';
		let actionName = '访问';
		let moduleName = modulevo.name;
		let systemName = currentSystem.name;
		await api.audit.save({actionCode,actionName,moduleName,systemName});
	},

	getActiveModuleAudit : () =>{
		activeModule = activeModule || appModule.getCurrPathModule();
		return {moduleName:activeModule.name,systemName:currentSystem.name};
	}
}



// WEBPACK FOOTER //
// ./src/services/module.ts